// @flow
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import "./styles.css";
import * as settingsActions from "../../action-creators/settings-actions";
import * as faqActions from "../../action-creators/faq-actions";
import Settings from "../../components/settings";
import type EventInfo from "../../models/event-info";
import type FAQ from "../../models/faq";

type PropsType = {
    actions: { [string]: any=>void },
    faqs: { [string]: FAQ },
    eventInfo: EventInfo
};


const MyScreen = ({ actions, eventInfo, faqs }: PropsType) => (

    <Settings
        saveEventInfo={ actions.updateSettings }
        saveFAQ={ actions.saveFAQ }
        deleteFAQ={ actions.deleteFAQ }
        reorderFAQs={ actions.reorderFAQs }
        faqs={ faqs.data }
        eventInfo={ eventInfo.data }
    />

);


const mapStateToProps = (state: Object): Object => {
    const { eventInfo, faqs } = state;
    return ({ eventInfo, faqs });
};

const mapDispatchToProps = (dispatch): Object => ({
    actions: bindActionCreators({ ...settingsActions, ...faqActions }, dispatch)
});

export const GreenUpDayScreen = connect(mapStateToProps, mapDispatchToProps)(MyScreen);
